//
//
//
//
//
//
//
//
//
//

import {
  defineComponent,
  onMounted,
  useMeta,
  toRefs,
  ref,
} from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    shopName: {
      type: String,
      required: true,
    },
    shopUrl: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      default: 'de_DE',
    },
  },
  setup(props) {
    const { shopName, shopUrl, locale } = toRefs(props)

    const shopIsLoading = ref(true)

    const timeoutForLoadingShop = 5000
    const delayAfterLoaded = 500

    const shopConfigAvalable = ref(false)

    onMounted(() => {
      setTimeout(() => (shopIsLoading.value = false), timeoutForLoadingShop)
    })

    useMeta(() => {
      // set spreadshirt-config only on client
      if (process.browser) {
        window.spread_shop_config = {
          shopName: shopName.value,
          locale: locale.value,
          prefix: shopUrl.value,
          baseId: 'shop',
          swipeMenu: true,
        }

        shopConfigAvalable.value = true
      }

      return {
        script: [
          {
            vmid: 'spreadshirt',
            src: 'https://nordbund.myspreadshop.net/js/shopclient.nocache.js',
            crossorigin: true,
            body: true,
            skip: !shopConfigAvalable.value,
            callback: () =>
              // stop loading animation with some delay after script has been loaded
              setTimeout(() => (shopIsLoading.value = false), delayAfterLoaded),
          },
        ],
      }
    })

    return { shopIsLoading }
  },
  head: {},
})
